/** User-visible copy that indicates an active or recent Xero API rate limit. */
export function isXeroRateLimitMessage(text) {
  const value = String(text || "").trim();
  if (!value) return false;
  return /rate limit|rate-limit|too many requests|try again after/i.test(value);
}

export function parseFutureTimestamp(value) {
  if (!value) return null;
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) && ms > Date.now() ? ms : null;
}

export function earliestActiveRateLimitUntilMs(report) {
  if (!report) return null;
  const candidates = [
    report.banner?.clearsAt,
    report.systems?.calls?.rateLimitedUntil,
    report.systems?.api?.rateLimitedUntil,
  ];
  let earliest = null;
  for (const raw of candidates) {
    const ms = parseFutureTimestamp(raw);
    if (ms == null) continue;
    if (earliest == null || ms < earliest) earliest = ms;
  }
  if (report.rateLimitPauseActive === true && earliest == null) {
    return Date.now() + 5000;
  }
  return earliest;
}

export function isRateLimitHealthBanner(banner) {
  if (!banner?.show) return false;
  return isXeroRateLimitMessage(banner.title);
}

/** Hide rate-limit banners once the pause window has ended (backend may lag one poll). */
export function shouldDisplayXeroHealthBanner(report) {
  const banner = report?.banner;
  if (!banner?.show) return false;
  if (!isRateLimitHealthBanner(banner)) return true;
  if (report?.rateLimitPauseActive === true) return true;
  if (report?.systems?.calls?.rateLimited || report?.systems?.api?.pausedForRateLimit) {
    return true;
  }
  return parseFutureTimestamp(banner.clearsAt) != null;
}
